jQuery(document).ready(function ($) {
    'use strict';

    var $pswp = $('.pswp');
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.attributeName === 'class') {
                if ($('.pswp--open').length) {
                    $('.mini-cart').addClass('inactive');
                    $('.action-bar.active').addClass('hidden');
                } else {
                    setTimeout(function() {
                        $('.mini-cart').removeClass('inactive');
                        $('.action-bar.active').removeClass('hidden');
                    }, 500);
                }
            }
        });
    });

    if($pswp.length > 0) {
        observer.observe($pswp[0], {
            attributes: true
        });
    }

    const gallery = $('.woocommerce-product-gallery').data('product_gallery');

    // Trigger lightbox on image click.
    $(document).on('click', '.woocommerce-product-gallery__trigger', function (e) {
        gallery.openPhotoswipe(e);
    });

    $(document).on('click', '.image-tools__video', function (e) {
        e.preventDefault();

        const $target = $(this);

        const vl = new VideoLightbox($target.data('video'));

        vl.show();
    });

    class VideoLightbox {
        constructor(url) {
            this.$el = $(
                '<div class="lightbox">' +
                    '<div class="lightbox__content">' +
                        '<div class="iframe-wrp">' +
                            '<iframe type="text/html" src="' + url + '" allow="autoplay; fullscreen" allowfullscreen width="100%" height="100%"></iframe>' +
                        '</div>' +
                    '</div>' +
                '</div>',
            );
        }

        show() {
            // Add to DOM.
            $(document.body).append(this.$el);

            // Make sure it's hidden.
            this.$el.hide();

            // Bind events.
            this.$el.find('.lightbox__close').on('click', () => this.close());
            this.$el.on('click', (e) => {
                if (!this.$el.is(e.target)) {
                    return;
                }

                this.close();
            });

            // Show it to the people!
            requestAnimationFrame(() => this.$el.fadeIn(300));
        }

        close() {
            // Fades it out and removes it from the DOM afterwards.
            requestAnimationFrame(() => $.when(this.$el.fadeOut(300)).then(() => this.$el.remove()));
        }
    }
});
